import {
  confirmPasswordReset,
  deleteUser,
  createUserWithEmailAndPassword as firebaseCreateUserWithEmailAndPassword,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
  signInAnonymously as firebaseSignInAnonymously,
  signInWithEmailAndPassword as firebaseSignInWithEmailAndPassword,
  signOut as firebaseSignOut,
  GoogleAuthProvider,
  getAuth,
  OAuthProvider,
  signInWithPopup,
  verifyPasswordResetCode,
} from 'firebase/auth'

class AuthenticationService {
  get auth() {
    return getAuth()
  }

  signInWithGoogle() {
    return signInWithPopup(this.auth, new GoogleAuthProvider())
  }

  signInWithApple() {
    const provider = new OAuthProvider('apple.com')
    provider.addScope('email')
    provider.addScope('name')

    return signInWithPopup(this.auth, provider)
  }

  signInWithEmailPassword(email: string, password: string) {
    return firebaseSignInWithEmailAndPassword(this.auth, email, password)
  }

  registerWithEmailPassword(email: string, password: string) {
    return firebaseCreateUserWithEmailAndPassword(this.auth, email, password)
  }

  sendPasswordResetEmail(email: string) {
    return firebaseSendPasswordResetEmail(this.auth, email)
  }

  confirmPasswordReset(oobCode: string, password: string) {
    return confirmPasswordReset(this.auth, oobCode, password)
  }

  verifyPasswordResetCode(oob: string) {
    return verifyPasswordResetCode(this.auth, oob)
  }

  signInAnonymously() {
    return firebaseSignInAnonymously(this.auth)
  }

  signOut() {
    return firebaseSignOut(this.auth)
  }

  deleteAccount() {
    const user = this.auth.currentUser
    if (!user) return
    return deleteUser(user)
  }

  refreshIdToken() {
    const user = this.auth.currentUser
    if (!user) return

    return user.getIdToken(true)
  }

  getAccessToken() {
    const user = this.auth.currentUser
    if (!user) return

    return user.getIdToken()
  }
}

const authenticationService = new AuthenticationService()

export default authenticationService
